<template>
	<svg role="status" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144.54 72.36">
		<defs>
		<component is="style">
				.a {
					fill: red;
				}
				.b {
					fill: #bfbfbf;
				}
			</component>
		</defs>
		<g>
			<rect class="a" y="45.12" width="14.6" height="27.24" rx="7.22"/>
			<rect class="a" x="27.05" y="35.9" width="14.6" height="36.46" rx="7.22"/>
			<rect class="b" x="54.6" y="26.87" width="14.6" height="45.5" rx="7.22"/>
			<rect class="b" x="78.78" y="17.88" width="14.6" height="54.49" rx="7.22"/>
			<rect class="b" x="104.31" y="10.29" width="14.6" height="62.07" rx="7.22"/>
			<rect class="b" x="129.94" width="14.6" height="72.36" rx="7.22"/>
		</g>
	</svg>
</template>
<script>
export default {
  name: "IconQualityLow",
}
</script>
